// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPhoto from "../Restaumatic.Menu.V2.Types.Photo/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $UIElement = (tag, _1) => ({tag, _1});
const DividerIsSymbol = {reflectSymbol: () => "Divider"};
const PictureIsSymbol = {reflectSymbol: () => "Picture"};
const CustomHtmlIsSymbol = {reflectSymbol: () => "CustomHtml"};
const Divider = /* #__PURE__ */ $UIElement("Divider");
const Picture = value0 => $UIElement("Picture", value0);
const CustomHtml = value0 => $UIElement("CustomHtml", value0);
const eqUIElement = {
  eq: x => y => {
    if (x.tag === "Divider") { return y.tag === "Divider"; }
    if (x.tag === "Picture") {
      if (y.tag === "Picture") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "CustomHtml") {
      if (y.tag === "CustomHtml") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const genericUIElement = {
  to: x => {
    if (x.tag === "Inl") { return Divider; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $UIElement("Picture", x._1._1); }
      if (x._1.tag === "Inr") { return $UIElement("CustomHtml", x._1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Divider") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Picture") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "CustomHtml") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)); }
    $runtime.fail();
  }
};
const showUIElement = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(DividerIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dPhoto.showPhoto.show(v)]})(PictureIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showStringImpl(v)]})(CustomHtmlIsSymbol);
    return x => {
      const $3 = genericUIElement.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeUIElement = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(DividerIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(PictureIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Unscramble.decodeString(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumConstruct(CustomHtmlIsSymbol)({unsafeDecodeSingleConstructorArgument: x => Unscramble.decodeString(x.contents)}))))(Unscramble$dGeneric.defaultOptions);
    return x => genericUIElement.to($0(x));
  })()
};
const encodeUIElement = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericUIElement)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(DividerIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(PictureIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg(
          "PlainArg",
          Foreign$dGeneric$dClass.genericEncodeConstructor(Restaumatic$dMenu$dV2$dTypes$dPhoto.PhotoIsSymbol)({
            encodeArgs: opts$1 => v$1 => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v$1), Data$dList$dTypes.Nil)
          }).encodeOpts(Foreign$dEncoding.options)(v)
        ),
        Data$dList$dTypes.Nil
      )
    });
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(CustomHtmlIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const decodeUIElement = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericUIElement)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(DividerIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PictureIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dPhoto.decodePhoto.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CustomHtmlIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign$dGeneric$dClass.readString}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))))
};
export {
  $UIElement,
  CustomHtml,
  CustomHtmlIsSymbol,
  Divider,
  DividerIsSymbol,
  Picture,
  PictureIsSymbol,
  decodeUIElement,
  encodeUIElement,
  eqUIElement,
  genericUIElement,
  showUIElement,
  unscrambleDecodeUIElement
};
